import type { TableViewType } from '../../types';
import { cardsViewSpec } from './cards';
import { gridViewSpec } from './grid';
import type { ViewValidationSpec } from './types';

/**
 * Mapping of view types to view validation.
 */
// Each entry is authored for its own view type, so its `normalize` takes the narrow
// `View` for that type. The record erases that per-key correlation and exposes the
// general `ViewValidationSpec`; the runtime always looks up the spec by matching view
// type, so the cast is sound.
export const viewSpecs: { [type in TableViewType]: ViewValidationSpec } = {
    grid: gridViewSpec,
    cards: cardsViewSpec,
} as { [type in TableViewType]: ViewValidationSpec };
